import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import moment from 'moment';

import MyShopStore from 'stores/MyShopStore';
import { generateID } from 'utils/helpers';
import APIStates from 'enum/APIStates';

import DiscountNotice from './DiscountNotice';
import PlayIcon from './PlayIcon';
import Preview from './Preview';
import Price from './Price';
import PurchaseSuccessfulNotification from './PurchaseSuccessfulNotification';
import styles from './index.css';


const IDS = {
  prefix: 'hsaklwe4',
  element: 'myShopThumbnail',
  thumbnail: 'thumbnail',
  thumbnailImage: 'thumbnailImage',
};
const makeId = generateID(IDS.prefix, IDS.element);

const MyShopThumbnail = (props) => {
  const {
    animationDone,
    hasAccess,
    isOverlay,
    item,
    onClick,
  } = props;

  const {
    coverImageUrl,
    discountEndDate,
    duration,
  } = item;

  const {
    playUrl,
    videoActionState,
  } = MyShopStore;

  const videoLoaded = (
    videoActionState === APIStates.LOADED &&
    isOverlay
  );

  const isDiscountActive = Boolean(
    discountEndDate &&
    moment(discountEndDate).diff(moment()) > 0
  );

  const priceElement = useMemo(() => {
    if (videoLoaded) {
      return null;
    }

    return (
      <Price
        isDiscountActive={isDiscountActive}
        item={item}
      />
    );
  }, [
    isDiscountActive,
    item,
    videoLoaded,
  ]);

  const discountNoticeElement = useMemo(() => {
    if (videoLoaded) {
      return null;
    }

    return (
      <DiscountNotice isDiscountActive={isDiscountActive} />
    );
  }, [
    isDiscountActive,
    videoLoaded,
  ]);

  const playIconElement = useMemo(() => {
    if (videoLoaded && !animationDone) {
      return null;
    }

    return (
      <PlayIcon
        hasAccess={hasAccess}
        playUrl={playUrl}
      />
    );
  }, [
    animationDone,
    hasAccess,
    playUrl,
    videoLoaded,
  ]);

  return (
    <div className={styles.thumbnail}>
      <Preview
        coverImageUrl={coverImageUrl}
        hasAccess={hasAccess}
        id={makeId(IDS.thumbnailImage)}
        onClick={onClick}
      />
      <div
        className={styles.content}
        id={makeId(IDS.thumbnail)}
        onClick={onClick}
      >
        {playIconElement}
        <span className={styles.duration}>
          {duration}
        </span>
        {discountNoticeElement}
        <PurchaseSuccessfulNotification videoLoaded={videoLoaded} />
      </div>
      {priceElement}
    </div>
  );
};

MyShopThumbnail.propTypes = {
  animationDone: PropTypes.bool,
  hasAccess: PropTypes.bool,
  isOverlay: PropTypes.bool,
  item: PropTypes.object,
  onClick: PropTypes.func,
};

MyShopThumbnail.defaultProps = {
  animationDone: undefined,
  hasAccess: false,
  isOverlay: false,
  item: undefined,
  onClick: () => undefined,
};

export default observer(MyShopThumbnail);
